import Navbar from "../../../components/Navbar";
import Quiz from "../../../components/Student/Quiz";

export default function QuizPage() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <Quiz />
        </div>
      </section>
    </>
  );
}
